import { render, staticRenderFns } from "./AddTranslationKey.vue?vue&type=template&id=724fc112&scoped=true&"
import script from "./AddTranslationKey.vue?vue&type=script&lang=js&"
export * from "./AddTranslationKey.vue?vue&type=script&lang=js&"
import style0 from "./AddTranslationKey.vue?vue&type=style&index=0&id=724fc112&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "724fc112",
  null
  
)

export default component.exports